import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { RoleManagmentUpdateComponent } from 'app/dialogs/role-managment-update/role-managment-update.component';
import { AuthService } from 'app/services/auth.service';
import { RoleService } from 'app/services/models/role.service';

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RoleListComponent implements OnInit {

  constructor(
    private roleService:RoleService,
    private ngbModal: NgbModal, 
    private _coreSidebarService: CoreSidebarService,
    public authService:AuthService) { }
    
  rows: any;
  public searchValue = '';
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  async ngOnInit() {
    await this.getAllRoles(this.pageBasic-1,this.selectedSize,this.searchValue,);
  }

  async getAllRoles(page,size,seacrh) {
    const roleAuthorization = this.authService.isEndpointStatus('GET.Reading.GetRoles');
    if(roleAuthorization){
      try {
        const data = await this.roleService.getAllRoles(page,size,seacrh);
        console.log(data)
        this.rows = data.roles;
        
        this.totalCount = data.totalCount;
      } catch (error) {
      }
    }
  }

  async onPageChange(pageNumber: number) {
    await this.getAllRoles(this.pageBasic-1,this.selectedSize,this.searchValue,);
  }
  async onOptionChange() {

    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllRoles(this.pageBasic-1,this.selectedSize,this.searchValue,);
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();

    this.searchValue = val;
    setTimeout(async () => {

      await this.getAllRoles(this.pageBasic-1,this.selectedSize,this.searchValue,);
    }, 2000);
  }
  async updateRoleManagementUpdate(data){
    const modalRefTransport = this.ngbModal.open(RoleManagmentUpdateComponent, {
      centered: true,
      size: 'sm',
      windowClass: 'modal modal-success',
    });
    modalRefTransport.componentInstance.data = data;
  }

  toggleSidebar(name): void {
    console.log(name);
    const sidebar = this._coreSidebarService.getSidebarRegistry(name);
    if (sidebar) {
      sidebar.toggleOpen();
    } else {
      console.error(`Sidebar with name ${name} not found`);
    }
  }
}
